module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1026-85dcf36785776613327e20a4fe7602fc.png";